"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectValidationSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var currenciesList_1 = require("common/global/currenciesList");
var donorsList_1 = require("common/global/donorsList");
var formik_1 = require("formik");
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("moment"));
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Yup = __importStar(require("yup"));
var useTitle_1 = __importDefault(require("../../hooks/useTitle"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var projectsSlice_1 = require("src/features/projects/projectsSlice");
exports.projectValidationSchema = Yup.object().shape({
    name: Yup.string()
        .min(2)
        .max(50)
        .required(),
    code: Yup.string()
        .required()
        .min(2),
    startingDate: Yup.date().required(),
    endingDate: Yup.string().required(),
    donorId: Yup.string().required(),
    currencyId: Yup.string().required(),
    thresholdForRequiringCBAFifthApproval: Yup.number().required(),
    thresholdForRequiringIRFifthApproval: Yup.number().required(),
});
var Option = antd_1.Select.Option;
function NewProject() {
    var _this = this;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(t("projects.NewProject"));
    var history = (0, react_router_dom_1.useParams)().history;
    var formProps = (0, formik_1.useFormik)({
        validationSchema: exports.projectValidationSchema,
        initialValues: {
            name: "",
            code: "",
            currencyId: "",
            donorId: "",
            PSCValue: 0,
            thresholdForRequiringCBAFifthApproval: 0,
            thresholdForRequiringIRFifthApproval: 0,
            startingDate: (0, moment_1.default)(),
            endingDate: (0, moment_1.default)(),
            hasSignature: false,
            mission: "turkeyMission",
        },
        onSubmit: function (values) { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, dispatch((0, projectsSlice_1.addProject)({
                                name: values.name,
                                code: values.code,
                                status: "planning",
                                currencyId: values.currencyId,
                                PSCValue: values.PSCValue,
                                donorId: values.donorId,
                                thresholdForRequiringCBAFifthApproval: values.thresholdForRequiringCBAFifthApproval,
                                thresholdForRequiringIRFifthApproval: values.thresholdForRequiringIRFifthApproval,
                                startingDate: values.startingDate,
                                endingDate: values.endingDate,
                                hasSignature: values.hasSignature,
                                mission: values.mission,
                            }))];
                    case 1:
                        _a.sent();
                        antd_1.message.success(t("alerts.success"));
                        navigate("/projects");
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.log(e_1);
                        antd_1.message.error(t("alerts.error"));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
    var formItemLayout = {
        labelCol: {
            xs: { span: 26 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
    };
    var dateFormat = "YYYY/MM/DD";
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: index_modules_css_1.default.profileBox }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_modules_css_1.default.infoBox }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({}, formItemLayout, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("name").touched) &&
                                formProps.errors.name &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("name").touched) &&
                                formProps.errors.name, label: t("projects.projectName"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.name, onChange: function (e) {
                                    return formProps.setFieldValue("name", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("code").touched) &&
                                formProps.errors.code &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("code").touched) &&
                                formProps.errors.code, label: t("projects.projectCode"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.code, onChange: function (e) {
                                    return formProps.setFieldValue("code", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("currencyId").touched) &&
                                formProps.errors.currencyId &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("currencyId").touched) &&
                                formProps.errors.currencyId, label: t("common.currency"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ showSearch: true, optionFilterProp: "children", value: formProps.values.currencyId, onChange: function (e) { return formProps.setFieldValue("currencyId", e); } }, { children: (0, lodash_1.map)(currenciesList_1.globalCurrenciesData, function (value, key) {
                                    return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: value.id }, { children: value.name }), key));
                                }) })) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("donorId").touched) &&
                                formProps.errors.donorId &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("donorId").touched) &&
                                formProps.errors.donorId, label: t("common.donor"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ showSearch: true, optionFilterProp: "children", onChange: function (e) { return formProps.setFieldValue("donorId", e); }, value: formProps.values.donorId }, { children: (0, lodash_1.map)(donorsList_1.globalDonorsData, function (value, key) {
                                    return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: value.id }, { children: value.name }), key));
                                }) })) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("thresholdForRequiringCBAFifthApproval").touched) &&
                                formProps.errors.thresholdForRequiringCBAFifthApproval &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("thresholdForRequiringCBAFifthApproval").touched) &&
                                formProps.errors.thresholdForRequiringCBAFifthApproval, label: t("projects.thresholdForRequiringCBAFifthApproval"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { type: "number", className: index_modules_css_1.default.formInputs, value: formProps.values.thresholdForRequiringCBAFifthApproval, onChange: function (e) {
                                    return formProps.setFieldValue("thresholdForRequiringCBAFifthApproval", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("thresholdForRequiringIRFifthApproval")
                                    .touched) &&
                                formProps.errors.thresholdForRequiringIRFifthApproval &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("thresholdForRequiringIRFifthApproval")
                                    .touched) &&
                                formProps.errors.thresholdForRequiringIRFifthApproval, label: t("projects.thresholdForRequiringIRFifthApproval"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { type: "number", className: index_modules_css_1.default.formInputs, value: formProps.values.thresholdForRequiringIRFifthApproval, onChange: function (e) {
                                    return formProps.setFieldValue("thresholdForRequiringIRFifthApproval", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("startingDate").touched) &&
                                formProps.errors.startingDate &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("startingDate").touched) &&
                                formProps.errors.startingDate, label: t("projects.startingDate"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { value: formProps.values.startingDate, format: dateFormat, onChange: function (e) {
                                    formProps.setFieldValue("startingDate", e);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("endingDate").touched) &&
                                formProps.errors.endingDate &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("endingDate").touched) &&
                                formProps.errors.endingDate, label: t("projects.endingDate"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { value: formProps.values.endingDate, format: dateFormat, onChange: function (e) {
                                    e.isAfter(formProps.getFieldMeta("startingDate").value)
                                        ? formProps.setFieldValue("endingDate", e)
                                        : antd_1.message.error(t("alerts.endingDateCannotBeBeforeStartingDate"));
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item
                        // validateStatus={
                        //     'error'
                        // }
                        , __assign({ 
                            // validateStatus={
                            //     'error'
                            // }
                            label: t("projects.hasSignature"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Switch, { checked: formProps.values.hasSignature, onChange: function (e) { return formProps.setFieldValue("hasSignature", e); } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("mission").touched) &&
                                formProps.errors.mission &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("mission").touched) &&
                                formProps.errors.mission, label: t("common.mission"), required: true }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Select, __assign({ showSearch: true, optionFilterProp: "children", onChange: function (e) { return formProps.setFieldValue("mission", e); }, value: formProps.values.mission }, { children: [(0, jsx_runtime_1.jsx)(Option, __assign({ value: "iraqMission" }, { children: "IRAQ" }), "iraqMission"), (0, jsx_runtime_1.jsx)(Option, __assign({ value: "turkeyMission" }, { children: "TURKEY" }), "turkeyMission")] })) })), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", onClick: formProps.submitForm, loading: formProps.isSubmitting }, { children: t("common.save") }))] })) })) })) })));
}
exports.default = NewProject;
